<template>
    <!-- <AppLayout title="Admins"> -->
         
         
         <v-card class="d-flex flex-column flex-grow-1 table-card" :class="tableCard.card.class" :rounded="tableCard.card.rounded">
             <v-card-text class="d-flex flex-column flex-grow-1" :class="tableCard.card.textClass">
                 <div class="d-flex align-center ga-3 px-3 px-md-0" :class="[tableCard.card.actionPad]">
                     <div class="d-flex flex-grow-1 min-w-0">
                         <div class="w-100 w-sm-20rem max-w-100">
                             <v-text-field
                                 v-model="datatable.request.search.value"
                                 :label="tableCard.searchInput.label"
                                 :placeholder="tableCard.searchInput.placeholder"
                                 :density="tableCard.searchInput.density"
                                 :flat="tableCard.searchInput.flat"
                                 :variant="tableCard.searchInput.variant"
                                 :single-line="tableCard.searchInput.singleLine"
                                 :hide-details="true"
                                 @update:model-value="() => datatable.onSearch()"
                                 clearable
                                 :class="[`table-action`, tableCard.searchInput.class]"
                             >
                             <template #prepend-inner >
                                 <span >
                                     <mdi-icon>search</mdi-icon>
                                 </span>
                             </template>
                             </v-text-field>
                         </div>
                     </div>
                     <div class="d-flex justify-end d-none" >
                     </div>
                 </div>
                 <div class="d-flex-col-grow">
                     <DataTable :datatable="datatable" class="d-flex flex-column"  >
                     </DataTable>
                 </div>
             </v-card-text>
         </v-card>
    <!-- </AppLayout> -->
</template>
<script setup lang="ts">
    import { ref } from "vue";
    import { Page, GlobalEventCallback } from '@inertiajs/core';
    import { usePage, Link, useForm } from '@inertiajs/vue3';
    import { SharedPageProps } from '@/Types/inertia';
    import { useDatatable } from '@/Composables/Datatable';
    import { toast } from "vue3-toastify";
    import { pageTitle, useTableCard, containerGapForTable } from '@/Composables/PageMeta';
    import { useAuth } from '@/Composables/Auth';
    import DataTable from '@/Components/vuetify/DataTable.vue';
    import helpers from '@/Plugins/helpers';
    import Notification from '@/Types/Models/notification';

    containerGapForTable();
    type PageData = SharedPageProps & {
        data:{
            table?: {
                datatable: any,
                columns: any
            };
        };
    }
    const ModuleName = 'Notifications';
    const { isSuperadmin } = useAuth();
    const page = usePage<PageData>();
    pageTitle.value = ModuleName;
    const datatable = useDatatable<Notification>(route('finances.topups.index'), page.props.data.table);


    const tableCard = useTableCard();

</script>